import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 默认不动态添加的路由
export const constantRoutes = [];

const createRouter = () => new Router({
  mode: 'history', // 去掉路由中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// 重置
export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router